/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { GridHeaderCustomVisibilityRuletModal } from '../header-actions/custom-visibility-rule-modal.component';
import { CQAppStore } from '../../../../../store/cq-app-store';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { AppliedRuleGridComponent } from '../../grid-applied-rule.component';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { ActionMapperController } from '../action-controller/action-mapper';
import UrlParam from './url-param.component';
import { CQAppConstant } from './../../../../../app-constants';
import GridRightPaneComponentName from './grid-right-pane-component-name';

interface Iprops{
    isBulkChecked: boolean,
    isApplyRuleModalVisisble: boolean,
    name: string,
    label: string,
    componentName: string,
    isFormValid: boolean,
    isActionSaved: boolean,
    actionType: string,
    isRuleApplied: boolean,
    visibilityRuleObj: any,
    visibilityRuleFields: any,
    isVisible: string,
    additionalFieldsArray: any,
    isComponentNameSpaceEditable:boolean,
    actionTypesArray:any[],
    parentFields:any[],
    headerActionType:any,
    urlParam: string,
    urlType:string,
    componentNameSpace:string,
    inputList:any[],
    isAddUrlParam:boolean
} 
export class AddedCustomHeaderActionComponent
    extends Component<{ selectedTemplateName: string, action: any }, Iprops> {
    private gridController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    constructor(props: Readonly<{ selectedTemplateName: string, action: any }>) {
        super(props);
        this.gridController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.state = {
            isBulkChecked: false,
            isApplyRuleModalVisisble: false,
            name: '',
            label: '',
            componentName: '',
            isFormValid: false,
            isActionSaved: false,
            actionType: '',
            isRuleApplied: false,
            visibilityRuleObj: {},
            visibilityRuleFields: [],
            isVisible: '',
            additionalFieldsArray: [],
            componentNameSpace: 'c-',
            headerActionType: 'custom_header_action',
            parentFields: [],
            actionTypesArray: ['VF_PAGE', 'LIGHTNING_COMPONENT'],
            isComponentNameSpaceEditable: false,
            urlParam:'',
            urlType:'',
            inputList:[{urlParam:'',urlType:''}],
            isAddUrlParam:true
        };
    }

    componentWillReceiveProps(nextProps: any) {
        const selectedAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const headerActions = gridObj.hasOwnProperty('headerActions') ? ruleElements.gridObject.headerActions : {};
        
        if (nextProps && nextProps.action.name !== this.props.action.name) {
            if (headerActions.hasOwnProperty(selectedAction.name)) {
                const ruleObject = { ...headerActions[selectedAction.name] }
                this.setState({
                    isBulkChecked: ruleObject.isBulkChecked,
                    isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                    name: ruleObject.name,
                    label: ruleObject.label,
                    componentName: ruleObject.componentName,
                    isFormValid: ruleObject.isFormValid,
                    isActionSaved: ruleObject.isActionSaved,
                    isRuleApplied: ruleObject.isRuleApplied,
                    visibilityRuleObj: ruleObject.visibilityRuleObj,
                    visibilityRuleFields: ruleObject.visibilityRuleFields,
                    isVisible: ruleObject.isVisible,
                    additionalFieldsArray: ruleObject.hasOwnProperty('additionalFieldsArray') ? ruleObject.additionalFieldsArray : [],
                    componentNameSpace:ruleObject.componentNameSpace,
                    actionType:ruleObject.actionType,
                    headerActionType:ruleObject.headerActionType,
                    inputList:ruleObject.inputList
                });
            } else {
                this.setState({
                    isBulkChecked: false,
                    isApplyRuleModalVisisble: false,
                    name: '',
                    label: '',
                    componentName: '',
                    isFormValid: false,
                    isActionSaved: false,
                    isRuleApplied: false,
                    visibilityRuleObj: {},
                    visibilityRuleFields: [],
                    isVisible: 'false',
                    additionalFieldsArray: [],
                    componentNameSpace: '',
                    isComponentNameSpaceEditable: false,
                    actionType: '',
                    headerActionType:'custom_header_action',
                    inputList:[{urlParam:'',urlType:''}]
                });
            }
        }
    }

    componentDidMount() {
        const selectedAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const headerActions = gridObj.hasOwnProperty('headerActions') ? ruleElements.gridObject.headerActions : {};
        
        if (headerActions.hasOwnProperty(selectedAction.name)) {
            const ruleObject = { ...headerActions[selectedAction.name] };
            this.setState({
                isBulkChecked: ruleObject.isBulkChecked,
                isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                name: ruleObject.name,
                label: ruleObject.label,
                componentName: ruleObject.componentName,
                isFormValid: ruleObject.isFormValid,
                isActionSaved: ruleObject.isActionSaved,
                isRuleApplied: ruleObject.isRuleApplied,
                visibilityRuleObj: ruleObject.visibilityRuleObj,
                visibilityRuleFields: ruleObject.visibilityRuleFields,
                isVisible: ruleObject.isVisible,
                additionalFieldsArray: ruleObject.hasOwnProperty('additionalFieldsArray') ? ruleObject.additionalFieldsArray : [],
                headerActionType:'custom_header_action',
                componentNameSpace:ruleObject.componentNameSpace,
                actionType:ruleObject.actionType,
                urlType:ruleObject.urlType,
                urlParam:ruleObject.urlParam,
                inputList:ruleObject.inputList
            });
        }
    }

    public render(): ReactNode {
        const { ruleObject }: any = this.extractStoreData();
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical full-height">
                            <h2 className="slds-text-heading_small slds-m-bottom_medium">Header Actions</h2>
                            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                                <dt className="slds-dl_horizontal__label">Custom Action</dt>
                            </dl>
                            <div className="slds-grid slds-grid_vertical full-height scroll-content">
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Name</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Name" value={this.state.name}
                                            onChange={this.onNameChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Label</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Label" value={this.state.label}
                                            onChange={this.onLabelChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element slds-grid slds-grid_vertical-align-center">
                                    <div className="slds-form-element__control">
                                        <input type="checkbox" name="checkbox-toggle-32" id="bulk"
                                            aria-describedby="checkbox-toggle-32"
                                            disabled={CQAppConstant.COMPONENT_ACTION_TYPES.includes(this.state.actionType)}
                                            checked={this.state.isBulkChecked}
                                            onChange={this.onBulkChange} />
                                    </div>
                                    <label className="slds-form-element__label slds-m-left_x-small">Bulk</label>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Action Type</label>
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select
                                                disabled={this.state.isBulkChecked}
                                                value={this.state.actionType} className="slds-select" id="select-02" onChange={this.setActionType}>
                                                <option value="">Please select</option>
                                                {this.state.actionTypesArray.map((actionType: any, index: number) => {
                                                    return (<option key={actionType + index}
                                                        value={actionType}>{actionType}</option>);
                                                })};
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <GridRightPaneComponentName
                                    isDisabled= {!this.state.actionType && !this.state.isBulkChecked}
                                    onSelect= {this.onComponentNameChange}
                                    actionType= {this.state.actionType}
                                    key= "addedCustomHeaderAction"
                                    value= {this.state.componentName}
                                />
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Component NameSpace</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" disabled={!this.state.isComponentNameSpaceEditable} placeholder="Add Component NameSpace" value={this.state.componentNameSpace}
                                            onChange={this.setComponentNameSpace} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                        <UrlParam
                                            setInputList={this.setInputList}
                                            inputList={this.state.inputList}
                                            isAddUrlParam={this.state.isAddUrlParam}
                                        />
                                </div>
                            {
                                this.state.isRuleApplied ? <AppliedRuleGridComponent ruleObject={ruleObject} toggleModalVisibility={this.toggleRuleModalVisibility} deleteRule={this.deleteRule} /> : <button disabled={!this.state.name} className="slds-button slds-button_brand full-width slds-m-bottom_small"
                                    onClick={() => { this.toggleRuleModalVisibility(); }}>Add Rule</button>
                            }
                            <button disabled={!this.state.isFormValid} className="slds-button slds-button_brand slds-m-bottom_small"
                                onClick={this.updateCustomAction}>Update Custom Action</button>

                            {
                                ruleObject && ruleObject.hasOwnProperty('isActionSaved') && ruleObject.isActionSaved && <button className="slds-button slds-button_brand"
                                    onClick={() => this.deleteCustomAction()}>Delete</button>
                            }
                           </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.isApplyRuleModalVisisble && <GridHeaderCustomVisibilityRuletModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        ruleObject={ruleObject}
                        actionType={this.state.name}
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                    />
                }
            </>
        );
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private extractStoreData = () => {
        let ruleObject = {};
        
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        if (gridObj.hasOwnProperty('headerActions')) {
            const headerActionsObject = { ...gridObj.headerActions };
            if (headerActionsObject.hasOwnProperty(this.state.name)) {
                ruleObject = headerActionsObject[this.state.name];
            }
        }
        return { ruleObject, gridObj };
    }

    public updateVisibilityRuleObj = (isRuleApplied: boolean, visibilityRuleObj: any, fields: any, isVisible: string, additionalFieldsArray: any) => {
        this.setState({
            isRuleApplied: isRuleApplied,
            visibilityRuleObj: visibilityRuleObj,
            visibilityRuleFields: fields,
            isVisible,
            additionalFieldsArray
        }, () => {
            this.isFormValid();
            // this.updateCustomAction();
        });
    }


    public deleteRule = () => {
        const selectedHeaderAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        this.gridActionsReducer.deleteViewModel(selectedHeaderAction.name.developerName, this.props.selectedTemplateName, 'headerActions');
        this.updateVisibilityRuleObj(false, {}, [], 'false', []);
        let headerFormRules = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'headerFormRules');
        if (headerFormRules.hasOwnProperty(this.state.name)) {
            delete headerFormRules[this.state.name]
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'headerFormRules', headerFormRules)
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private toggleRuleModalVisibility = () => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onComponentNameChange = (addedVal: string, nameSpacePrefix: string) => {
        this.setState({
            componentName: addedVal,
            componentNameSpace: this.state.actionType === 'VF_PAGE'? 
                                    nameSpacePrefix ? nameSpacePrefix+'__' : 'compliancequest__' 
                                    :
                                    nameSpacePrefix ? nameSpacePrefix : this.state.componentNameSpace,
            isComponentNameSpaceEditable: false
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onBulkChange = () => {
        this.setState({
            name:!this.state.isBulkChecked?'showEditSelected':''
        })
        this.setState({
            isBulkChecked: !this.state.isBulkChecked
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @param {BaseSyntheticEvent} e for action Type selected
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private setActionType = (e: BaseSyntheticEvent) => {
        const actionType = e.target.value;
        const popupType = actionType === 'VF_PAGE' ? false : true;
        if(actionType){
            this.setState({
                isBulkChecked:false
            })
        }
        this.setState({
            actionType,
            componentNameSpace: popupType ? 'c__' : this.state.componentNameSpace,
            componentName: '',
        }, () => {
            this.isFormValid();
        })
    }

    /**     
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private setInputList = (inputList:any[],isAddUrlParam:boolean)=>{
        this.setState({inputList:inputList, isAddUrlParam:isAddUrlParam})
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onLabelChange = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            label: enteredVal
        }, () => {
            this.isFormValid();
        });
    }


    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onNameChange = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            name: enteredVal
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private setComponentNameSpace = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            componentNameSpace: enteredVal
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private isFormValid = () => {
        if (!this.state.name || !this.state.label || (!this.state.componentName && !this.state.isBulkChecked)) {
            this.setState({
                isFormValid: false
            });
        } else {
            this.setState({
                isFormValid: true
            });
        }
        if (this.state.isRuleApplied) {
            this.setState({
                isFormValid: true
            });
        }
    }

    private deleteCustomAction = () => {
        this.gridController.resetCustomAction(this.state.name, this.props.selectedTemplateName);
    }

    private updateCustomAction = () => {
        CQAppStore.loader.setVisibility(true);
        if (this.state.isFormValid) {
            this.setState({
                isActionSaved: true
            }, () => {
                this.updateRuleElements();
                const actionObject: any = ActionMapperController[this.state.headerActionType].getControllerInstance(this.state);
                this.saveDataToStore(actionObject);
                this.saveToOrderingList(actionObject);
                setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
            });
        }
    }

    private saveToOrderingList = (actionObject: any) => {
        let orderedHeaderActions = [...CQMasterDataStore.GridObject.orderedHeaderActions];
        if (!actionObject.actionJSON.hasOwnProperty('headerFormRules')) {

            const ifExist = orderedHeaderActions.map((orderedAction: any, index: number) => {
                let action = { ...orderedAction };
                if (action.actionJSON.hasOwnProperty('headerActions') && action.actionJSON.headerActions.name === this.state.name) {
                    orderedHeaderActions[index] = actionObject;
                    return true;
                }
                // else if (action.actionJSON.hasOwnProperty('headerFormRules') && action.actionJSON.headerFormRules.name === this.state.name) {
                //     orderedHeaderActions[index] = actionObject;
                //     return true
                // }
                return false;
            });
            if (!ifExist) {
                orderedHeaderActions.push(actionObject);
            }
            CQMasterDataStore.GridObject.updateGridField('orderedHeaderActions', orderedHeaderActions);
        } else {
            orderedHeaderActions.forEach((orderedAction: any, index: number) => {
                let action = { ...orderedAction };
                if (action.actionJSON.hasOwnProperty('headerActions') && action.actionJSON.headerActions.name === this.state.name) {
                    orderedHeaderActions.splice(index, 1);
                }
            });
            CQMasterDataStore.GridObject.updateGridField('orderedHeaderActions', orderedHeaderActions);
        }
    }

    private saveDataToStore = (actionObject: any) => {
        const outputConfig = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        actionObject && Object.keys(actionObject.actionJSON).length && Object.keys(actionObject.actionJSON).map((objKey: string) => {
            if (objKey === 'headerFormRules') {
                const headerFormRules = { ...outputConfig.headerFormRules, ...actionObject.actionJSON[objKey] };
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerFormRules);
            } else if (objKey === 'headerActions') {
                let headerActions = [...outputConfig.headerActions];
                const ifExist = headerActions.map((action: any, index: number) => {
                    if (action.name === this.state.name) {
                        headerActions[index] = { ...actionObject.actionJSON[objKey] };
                        return true;
                    }
                    return false;
                });
                if (!ifExist) {
                    headerActions.push({ ...actionObject.actionJSON[objKey] });
                }
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerActions);
            }
        });
        const parentFields = [...outputConfig.parentFields, ...this.state.visibilityRuleFields];
        if (parentFields.length) {
            const parentFieldsArray = Array.from(new Set(parentFields));
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'parentFields', parentFieldsArray);
        }
    }

    private updateRuleElements = () => {
        const ruleElementsObj = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = { ...ruleElementsObj.gridObject };
        const headerActions = { ...gridObj.headerActions };
        headerActions[this.state.name] = { ...headerActions[this.state.name], ...this.state };
        gridObj.headerActions = headerActions;
        ruleElementsObj.gridObject = gridObj;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
    }
}

export const AddedCustomHeaderActionRootComponent = observer(
    AddedCustomHeaderActionComponent
);